import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult } from '@azure/msal-browser';
import { from, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private msalService: MsalService, private router: Router) {
    // this.msalService.instance.handleRedirectPromise().then((response: AuthenticationResult | null) => {
    //   if (response && response.account) {
    //     this.msalService.instance.setActiveAccount(response.account);
    //     this.storeToken(response.accessToken); // Store the token in localStorage
    //     this.router.navigate(['/home']);
    //   }
    // }).catch(error => {
    // });

    this.msalService.handleRedirectObservable().subscribe({
      next: (result: AuthenticationResult) => {
        // this.setLoginDisplay();

        // this.authService.instance.setActiveAccount(result.account);
        if(result){
        this.msalService.instance.setActiveAccount(result.account);
        this.storeToken(result.accessToken);
        // this.router.navigate(['/home']);
      }
      },
      error: (error) => console.log(error)
    });
  }

  login() {
    this.msalService.loginRedirect();
  }

  logout() {
    this.msalService.logout();
    localStorage.removeItem('sso_token'); // Remove the token from localStorage on logout
  }

  isAuthenticated(): boolean {
    return this.msalService.instance.getAllAccounts().length > 0;
  }

  getToken(): Observable<string | null> {
    const account = this.msalService.instance.getActiveAccount();
    if (account) {
      const tokenPromise = this.msalService.instance.acquireTokenSilent({
        account,
        scopes: ["user.read"]
      }).then(response => {
        this.storeToken(response.accessToken); // Store the token in localStorage
        return response.accessToken;
      }).catch(error => {
        return null;
      });
      return from(tokenPromise);
    }
    return from(Promise.resolve(null));
  }

  private storeToken(token: string | null) {
    if (token) {
      localStorage.setItem('sso_token', token);
    }
  }

  getStoredToken(): string | null {
    const token = localStorage.getItem('sso_token');
    return token;
  }
}
